import React from 'react';
import JepsplSection from '../../../../../components/course/churchschool/JepsplSection';
import WarningSection from '../../../../../components/course/churchschool/WarningSection';
import HFHJSection8b from '../../../../../components/course/churchschool/hfhj/HFHJSection8b';
import HFHJSection14 from '../../../../../components/course/churchschool/hfhj/HFHJSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../../components/course/churchschool/event/GodDealWeekSectionOct';

const BoostupHJBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}
      <HFHJSection8b />
      <WarningSection />
      <JepsplSection />
      <HFHJSection14 />
    </>
  );
};

export default BoostupHJBookMain;
